<template>
  <div class="device-detail-report">
    <div class="sheet-info">
      <ul class="box">
        <li class="item">
          <h2>{{ $t('dms_device_detail_report.ce_shi_bao_gao') }}</h2>
          <p>{{ reportNum }}{{ $t('dms_device_detail_report.fen') }}</p>
        </li>
        <li class="item" v-if="type!=='batteryManagement'">
          <h2>
            {{
              'Modem SN'
            }}
          </h2>
          <!-- this.deviceInfo.modemSn -->
          <p>{{ modemSn || '-'}}</p>
        </li>
        <li class="item" v-else>
          <h2>
            {{ $t('dms_device_detail_report.dian_chiSN') }}
          </h2>
          <!-- this.deviceInfo.modemSn -->
          <p>{{ batterySn|| '-' }}</p>
        </li>

      </ul>
    </div>
    <div class="report-list" v-if="reportNum > 0">
      <p class="titel">
        {{ $t('dms_device_detail_report.zxcsbg') }}
      </p>
      <ul>
        <li
          class="card-line"
          v-for="(item, index) in reportListNew"
          :key="index"
        >
          <div class="icon">
            <i class="icon icon-ceshibaogao current"></i>
          </div>
          <div class="info">
            <p>{{ $t('dms_device_detail_report.ce_shi_shi_jian') }}</p>
            <span class="value">{{ momentAmPm($momentLocal(item.gmtCreate)) }}</span>
          </div>
          <div class="inner">
            <div class="param">
              <div class="name">
                <p>
                  {{ $t('dms_device_detail_report.ce_shi_jie_guo') }}
                </p>
                <span class="value">{{
                  isynergy_cloud_approval_result[item.reportState]
                }}</span>
              </div>
              <div class="name">
                <p>
                  {{
                    $t('dms_device_detail_report.ce_shi_shi_wen')
                  }}
                </p>
                <span class="value">{{ $celsiusToFahrenheit(item.envTemp) }}{{$formatTempUnit()}}</span>
              </div>
              <div class="name">
                <p>{{ $t('dms_device_detail_report.ce_shi_ren') }}</p>
                <span class="value">{{ item.creator }}</span>
              </div>
              <div class="name" v-if="testType==='1'&&type!=='batteryManagement'">
                <p>{{ $t('dms_device_detail_report.dian_chiSN') }}</p>
                <span class="value">{{ item.batterySn||'-' }}</span>
              </div>
              <div class="name" v-if="type==='batteryManagement'">
                <p> {{'Modem SN' }}</p>
                <span class="value">{{ item.modemSn||'-' }}</span>
              </div>
              <div class="name" v-if="testType==='9'">
                <p>{{ $t('dms_device_detail_report.ji_shen_hao') }}</p>
                <span class="value">{{ item.bodyNum ||'-' }}</span>
              </div>
            </div>
          </div>
          <div class="more">
            <!-- <div class="pdf">
              {{ $t('com_export_pdf') }}
            </div> -->
            <div class="details" @click="reportDetails(item.testReportId)">
              {{ $t('dms_device_detail_report.cha_kan_xiang_qing') }}
              <i class="icon icon-you"></i>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="report-list-history" v-if="reportListOld.length > 0">
      <p class="titel">
        {{ $t('dms_device_detail_report.lscsbg') }}
      </p>
      <ul>
        <li
          class="card-line"
          v-for="(item, index) in reportListOld"
          :key="index"
        >
          <div class="icon">
            <i class="icon icon-ceshibaogao"></i>
          </div>
          <div class="info">
            <p>{{ $t('dms_device_detail_report.ce_shi_shi_jian') }}</p>
            <span class="value">{{  momentAmPm($momentLocal(item.gmtCreate)) }}</span>
          </div>
          <div class="inner">
            <div class="param">
              <div class="name">
                <p>
                  {{ $t('dms_device_detail_report.ce_shi_jie_guo') }}
                </p>
                <span class="value">{{
                  isynergy_cloud_approval_result[item.reportState]
                }}</span>
              </div>
              <div class="name">
                <p>
                  {{
                    $t('dms_device_detail_report.ce_shi_shi_wen')
                  }}
                </p>
                <span class="value">{{ $celsiusToFahrenheit(item.envTemp) }}{{$formatTempUnit()}}</span>
              </div>
              <div class="name">
                <p>{{ $t('dms_device_detail_report.ce_shi_ren') }}</p>
                <span class="value">{{ item.creator }}</span>
              </div>
              <div class="name" v-if="testType==='1'&&type!=='batteryManagement'">
                <p>{{ $t('dms_device_detail_report.dian_chiSN') }}</p>
                <span class="value">{{ item.batterySn||'-' }}</span>
              </div>
              <div class="name" v-if="type==='batteryManagement'">
                <p> {{'Modem SN' }}</p>
                <span class="value">{{ item.modemSn||'-' }}</span>
              </div>
              <div class="name" v-if="testType==='9'">
                <p>{{ $t('dms_device_detail_report.ji_shen_hao') }}</p>
                <span class="value">{{ item.bodyNum ||'-' }}</span>
              </div>
            </div>
          </div>
          <div class="more">
            <!-- <div class="pdf">
              {{ $t('com_export_pdf') }}

            </div> -->
            <div class="details" @click="reportDetails(item.testReportId)">
              {{ $t('dms_device_detail_report.cha_kan_xiang_qing')}}
              <i class="icon icon-you"></i>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <device-reportDetail-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      :testReportId="testReportId"
      :modemSn="modemSn"
      :testType="testType"
      @close="dialogVisible = false"
    ></device-reportDetail-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import deviceReportDetailDialog from './device_reportDetail_dialog.vue';

export default {
  components: {
    deviceReportDetailDialog
  },
  props: {
    deviceInfo: [String, Object, Array],
  },
  data() {
    return {
      // modemSn: '20200509001',
      modemSn: '',
      batterySn: '',
      reportNum: '',
      reportListNew: [],
      reportListOld: [],
      isynergy_cloud_approval_result: {},
      // 卡机卡弹窗
      dialogVisible: false,
      dialogModel: {},
      testReportId: {},
      type: '',
      testType: ''// 测试类型:1-电池，9-整机

    };
  },
  mounted() {
    this.getDictionary('isynergy_cloud_approval_result', (data) => {
      this.isynergy_cloud_approval_result = this.$transformDicValue(
        data.isynergy_cloud_approval_result
      );
    });
    this.modemSn = this.deviceInfo.modemSn || '';
    this.batterySn = this.deviceInfo.batterySn || '';
    this.type = this.getJump('type');
    this.testType = this.getJump('testType') || '9';// 设备详情是整机的
    this.getReportList();
  },
  methods: {
    getReportList() {
      // modemSn: '20200509001',
      // modemSn: this.deviceInfo.modemSn
      if (`${this.type}` === 'batteryManagement') {
        this.$getJSON(apis.DeviceTestReportList, { batterySn: this.batterySn, testType: this.testType }).then(
          (res) => {
            this.reportListNew = res.data.reports.slice(-1);
            this.reportListOld = res.data.reports.slice(
              0,
              res.data.reports.length - 1
            );
            this.reportNum = res.data.reportNum;
          }
        );
      } else {
        this.$getJSON(apis.DeviceTestReportList, { modemSn: this.modemSn, testType: this.testType }).then(
          (res) => {
            this.reportListNew = res.data.reports.slice(-1);
            this.reportListOld = res.data.reports.slice(
              0,
              res.data.reports.length - 1
            );
            this.reportNum = res.data.reportNum;
          }
        );
      }
      // 设备详情用bodynum维度去查

    },
    reportDetails(testReportId) {
      this.dialogVisible = true;
      this.dialogModel.type = 'see';
      this.testReportId = testReportId;
    }
  }
};
</script>

<style lang="scss">
.device-detail-report {
  padding: 24px;
  .sheet-info {
    // padding-top:16px;
    .box {
      padding: 21px 22px;
      background-color: #f9f9fd;
      display: flex;
      li {
        border-right: 1px solid #e9ebec;
        padding: 0 56px 0 23px;
        h2 {
          height: 17px;
          font-size: 12px;
          color: rgba(152, 166, 173, 1);
          line-height: 17px;
          margin-bottom: 5px;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        p {
          height: 26px;
          font-size: 20px;
          // font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: rgba(57, 70, 104, 1);
          line-height: 26px;
        }
        &:last-of-type {
          border: none;
        }
      }
    }
  }

  .report-list,
  .report-list-history {
    margin-top: 32px;
    padding: 25px 15px 16px 15px;
    border: 1px solid #e9ebec;
    position: relative;
    .titel {
      height: 17px;
      font-size: 12px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 17px;
      padding: 0 14px;
      background-color: #fff;
      position: absolute;
      left: 24px;
      top: -8.5px;
    }
    ul {
      li {
        height: 70px;
        background: #ffffff;
        padding: 13px 17px 13px 16px;
        display: flex;
        align-items: center;
        // justify-content: space-between;
        .icon {
          width: 44px;
          height: 44px;
          margin-right: 24px;
          .icon {
            font-size: 44px;
            color: #d1d5d9;
          }
          .current {
            color: #0d9ae0;
          }
        }
        .info {
          margin-right: 44px;
          p {
            height: 17px;
            font-size: 12px;
            color: rgba(73, 80, 87, 1);
            line-height: 17px;
          }
          span {
            height: 25px;
            font-size: 13px;

            font-weight: bold;
            color: rgba(73, 80, 87, 1);
            line-height: 25px;
          }
        }
        .inner {
          flex: 1;

          .param {
            display: flex;
            overflow-x: auto;
            .name {
              padding: 0 24px 0 20px;
              border-right: 1px solid #e9ebec;
              flex-shrink: 0;
              text-align: center;
              p {
                height: 17px;
                font-size: 12px;
                color: rgba(152, 166, 173, 1);
                line-height: 17px;
              }
              span {
                height: 25px;
                font-size: 13px;

                font-weight: bold;
                color: rgba(73, 80, 87, 1);
                line-height: 25px;
              }
              &:last-of-type {
                border: none !important;
              }
            }
          }
        }
        .card-title {
          height: 21px;
          font-size: 12px;

          font-weight: bold;
          color: rgba(73, 80, 87, 1);
          line-height: 21px;
          .user {
            height: 21px;
            font-size: 12px;
            color: rgba(57, 70, 104, 1);
            line-height: 21px;
          }
          .right {
            float: right;
            height: 17px;
            font-size: 12px;
            color: rgba(13, 154, 224, 1);
            line-height: 17px;
          }
        }
        .card-tips {
          height: 17px;
          font-size: 12px;
          color: rgba(108, 117, 125, 1);
          line-height: 17px;
          .right {
            float: right;
            height: 17px;
            font-size: 12px;
            color: rgba(108, 117, 125, 1);
            line-height: 17px;
          }
        }
        &:hover {
          background: #f9f9fd;
        }
        .more {
          margin-left: auto;
          display: flex;
          .pdf,
          .details {
            flex-shrink: 0;
            color: #0d9ae0;
            font-size: 12px;
            color: rgba(13, 154, 224, 1);
            line-height: 22px;
            cursor: pointer;
            padding: 0 20px;
            border-right: 1px solid #e9ebec;
            i {
              color: #0d9ae0;
              font-size: 12px;
              margin: 0;
            }
          }
          .details {
            padding-right: 0;
            border: none;
          }
        }
      }
    }
  }
}
</style>
